import React , { useState, useEffect} from 'react';
import { useSelector } from 'react-redux'
import { useHistory, Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Box from '@mui/system/Box';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import ProductCategories from './Categories';
import LeftMenus from './LeftMenus';
import DashboardComp from './Dashboard';
import SubCategories from './SubCategoreis';
import AddNewButton from './AddNewButton';
import ProductLists from './ProductLists';
import AddCategory from './Categories/AddCategory';
import AddSubCategory from './SubCategoreis/AddSubCategory';
import AddProduct from './AddProduct';
import { useCommonStyles } from '../../common/common';
import Sellers from './Sellers';
import EditSeller from './Sellers/EditSeller';
import { AppState } from '../../store';
import CustomersList from './Customers';
import { TopProductSellers } from '../../store/types/actions/ProductAction';
import OrderLists from './Orders';

const Admin  = (props: any) => {
    const { section } = props.match.params;
    const [selectedListItem, setSelectedListItem] = useState(`/${section || 'dashboard'}`)
    const [open, setOpen] = useState(false)
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [selectedOrder, setSelectedOrder] = useState(null)
    const [selectedCustomerId, setSelectedCustomer] = useState('')
    const [selectedSeller, setSelectedSeller] = useState<TopProductSellers | null>(null)
    const {topSellers} = useSelector<AppState, AppState['products']>(
        ({products}) => products,
    );
    
    const history = useHistory()
    const commonClasses = useCommonStyles()
    
    useEffect(() => {
        if(selectedListItem === '/sellers') { 
            const filteredSeller = 
                topSellers && topSellers.length > 0 &&
                topSellers.filter((seller: any) => seller._id === selectedCustomerId)
                if(filteredSeller && filteredSeller.length > 0) {
                    setSelectedSeller({...filteredSeller[0] })
                }
        }
    }, [topSellers, selectedCustomerId, selectedListItem, open])

    const setSelectedListItemHandler = (path: string) => {
        setSelectedListItem(path);
        setOpen(false);
        history.push('/admin' + path)
    }

    const addNewClickHandler = (open: boolean) => {
        setOpen(open);
        setSelectedProduct(null)
        setSelectedCategory(null)
        setSelectedSeller(null)
    }

    const handleSelectedProduct = (p: any) => {
        setSelectedProduct(p)
        setOpen(true);
    }

    const handleSelectedCategory = (p: any) => {
        setSelectedCategory(p)
        setOpen(true);
    }

    const handleSelectCustomer = (c: string) => {
        setSelectedCustomer(c)
        setOpen(true);
    }

    const handleCancel = (from: string) => {
        setOpen(false)
        if(from === 'category') {
            setSelectedCategory(null)
        } else {
            // for subcategory
        }
    }

    return (
        <>
            <Box display="flex" flexDirection="row" p={2} component="h5">
                <Link to="/products" className={commonClasses.loginLink}
                    style={{color: '#000'}}
                >
                    <KeyboardBackspaceIcon /> Back to Shop
                </Link>
                <Box
                    component="span" 
                    display="flex"
                    justifyContent="flex-end"
                    flex={1}
                    mr={1}
                >Admin Panel</Box>
            </Box>
            <Grid container spacing={3} style={{padding: '16px'}}>
                <Grid item xs={12} sm={3} md={2}>
                    <LeftMenus
                        selectedListItem={selectedListItem}
                        setSelectedListItemHandler={setSelectedListItemHandler}
                    />
                </Grid>
                <Grid item xs={12} sm={9} md={10}>
                    {  selectedListItem !== '/dashboard' && !open && selectedListItem !== '/sellers' &&
                        <AddNewButton
                            addNewClickHandler={addNewClickHandler}
                            selectedListItem={selectedListItem} 
                        />
                    }
                    { selectedListItem === '/dashboard' && !open && 
                        <DashboardComp
                            setOpen={setOpen}
                            selectedListItem={selectedListItem}
                            setSelectedListItemHandler={setSelectedListItemHandler}
                        />
                    }
                    {/* categories, Add/Edit category */}
                    {  selectedListItem === '/categories' && !open &&
                        <ProductCategories
                            open={open}
                            setOpen={setOpen}
                            cancel={handleCancel}
                            selectedCategory={selectedCategory}
                            handleSelectedCategory={handleSelectedCategory}
                        />
                    }
                    {  selectedListItem === '/categories' && open &&
                        <AddCategory
                            setOpen={setOpen}
                            cancel={handleCancel}
                            selectedCategory={selectedCategory}
                        />
                    }

                    {/* sub-categories, Add sub-category */}
                    {  selectedListItem === '/sub-categories' && !open &&
                        <SubCategories open={open} setOpen={setOpen} />
                    }
                    {  selectedListItem === '/sub-categories' && open &&
                        <AddSubCategory setOpen={setOpen} />
                    }

                    {/* products, Add product */}
                    {  selectedListItem === '/products' && !open &&
                        <ProductLists handleSelectedProduct={handleSelectedProduct} />
                    }
                    {  selectedListItem === '/products' && open &&
                        <AddProduct setOpen={setOpen} selectedProduct={selectedProduct} />
                    }

                    {/* sellers */}
                    {  selectedListItem === '/sellers' && !open &&
                        <Sellers handleSelectedCustomer={handleSelectCustomer} />
                    }
                    {  selectedListItem === '/sellers' && open && selectedSeller &&
                        <EditSeller setOpen={setOpen} selectedSeller={selectedSeller} />
                    }

                    {/* customers */}
                    {  selectedListItem === '/customers' && !open &&
                        <CustomersList handleSelectedCustomer={handleSelectCustomer} />
                    }

                    {/* orders */}
                    {  selectedListItem === '/orders' && !open &&
                        <OrderLists handleSelectedOrder={handleSelectCustomer} />
                    }
                </Grid>
            </Grid>
        </>
    )
}

export default Admin;
